import React from 'react';
import { makeStyles } from '@mui/styles';
import Modal from '@mui/material/Modal';
import { Typography } from '@mui/material';
import TModalFacturasPC from './TModalFacturasPC';

function rand() {
  return Math.round(1 * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: '80%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 0,
  },
}));

export default function ModalFacturasPC({
  open,
  handleClose,
  data,
  seleccionar,
}) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const handleCloseModal = () => {
    handleClose();
  };
  const body = (
    <div style={modalStyle} className={classes.paper}>
      <Typography
        id="simple-modal-title"
        component="h3"
        variant="h4"
        color="primary"
      >
        Seleccionar Facturas
      </Typography>
      <div notranslate="true">
        <TModalFacturasPC rows={data} seleccionar={seleccionar} />
      </div>
    </div>
  );
  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </React.Fragment>
  );
}
